import * as React from 'react';
import { Link } from 'react-router-dom';
import { PageBody, PageContent, PageHeading } from '../../../../components/page-components/_index';
import { StatusCode } from '../../../../utils/api';
import { PageNames, Routes } from '../../../../utils/app-constants';
import { navigateToPage } from '../../../../utils/history';
import { ImportRouteRow } from '../components/ImportRouteRow';
import { TruckRead } from '../../../../transportation/models/trucks/truck-read';
import { TransportationSvc } from '../../../../transportation/service';
import '../../../../transportation/styles.scss';

export const ImportStopFileScene = () => {

    const [service]                     = React.useState(new TransportationSvc());
    const [stopFile, setStopFile]       = React.useState<any>();
    const [routes, setRoutes]           = React.useState([] as TruckRead[]);
    const [showRoutes, setShowRoutes]   = React.useState(false);
    const [processedCount, setProcessedCount] = React.useState(0);

    /**
     * Uploaded the selected file to the server
     * and process the response
     */
    const uploadStopFile = async () => {
        const formData = new FormData();
        formData.append("file", stopFile);

        const tSvc = new TransportationSvc();
        const response = await tSvc.importStopFile(formData);

        if (response.status === StatusCode.Success) {
            setRoutes(response.data);
            setShowRoutes(true);
            setStopFile(null);
        }
        
    };

    /**
     * Get the selected file and put that in to our 
     * state
     * @param evt File upload event
     */
    const setFile = (evt: any) => {
        setStopFile(evt.target.files[0]);
    };

    const onSave = async (truckName : string, clientTruckId : string) => {       

        const truck = routes.find((itm : TruckRead) => {
            return itm.tmpClientId === clientTruckId;
        });

        if (truck) {

            truck.name = truckName;

            const response = await service.saveRoute(truck);
            if (response.status === StatusCode.Success) {
                const tmpRoutes = [...routes];
                const idx = tmpRoutes.findIndex((itm : TruckRead) => {
                    return itm.tmpClientId === clientTruckId;
                });

                tmpRoutes.splice(idx, 1);
                setRoutes(tmpRoutes);
            }
        }
        
    };

    const onCancel = () => {
        setStopFile(null);
        setRoutes([]);
        setShowRoutes(false);
    };

    return <PageContent pageName={PageNames.TRANSPORTATION_PLANNING_IMPORT}>
            <PageHeading 
                shouldStick={ true }
                showBackBtn={ true }
                onBackClick={ () => navigateToPage(Routes.ROUTING_ROUTING) }
                title="Import Direct Route File" />
            <PageBody>
                {
                    showRoutes && routes
                        ? <React.Fragment>
                            {
                                routes.length > 0
                                    ? <div className="row">
                                        <div className="col">
                                            <h1 className="import-result">
                                                Success! We found <u>{ routes.length }</u> routes in your stop file. 
                                            </h1>
                                            <p>Review the details and if you're satisfied with everything, add a truck name and click the "Import" button to create it.
                                                <span>
                                                    Note: Any routes not selected for import will return to the unplanned pool.
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                routes.map((item: TruckRead, idx: number) =>
                                    <ImportRouteRow 
                                        key={ item.tmpClientId } 
                                        tIndex={ idx * 2 }
                                        route={ item } 
                                        onSave={ onSave }
                                    />
                                )
                            }
                            {
                                routes.length === 0
                                    ? <div className="row">
                                        <div className="col text-center">
                                            <h2>All Done!</h2>
                                            <p>Click <Link to={ Routes.ROUTING_ROUTING }>here</Link> to return to the planning list.</p>
                                        </div>
                                    </div>
                                    : null
                            }

                        </React.Fragment>
                        : <div className="file-upload">
                            <form onSubmitCapture={(e) => e.preventDefault()}>
                                <label htmlFor="direct-route-import">
                                    <i className="la la-upload" />
                                    {
                                        stopFile
                                            ? <span>{ stopFile.name }</span>
                                            : <span>Choose Direct Route File...</span>
                                    }                                
                                </label>
                                <input 
                                    id="direct-route-import" 
                                    accept=".upl" 
                                    type="file" 
                                    name="file" 
                                    onChange={setFile} />
                                {
                                    stopFile
                                        ? <button className="btn" onClick={ uploadStopFile }>Upload for processing</button>
                                        : null
                                }
                            </form>
                        </div>                 
                }
            </PageBody>
    </PageContent>;
};
